"use client";

import { useState, useCallback } from "react";

export interface CompareToastState {
  show: boolean;
  message: string;
  type: "error" | "success" | "info";
}

export const useCompareToast = (duration = 3000) => {
  const [toast, setToast] = useState<CompareToastState>({
    show: false,
    message: "",
    type: "info",
  });

  const showToast = useCallback(
    (message: string, type: "error" | "success" | "info" = "info") => {
      setToast({
        show: true,
        message,
        type,
      });

      const timer = setTimeout(() => {
        setToast((prev) => ({ ...prev, show: false }));
      }, duration);

      return () => clearTimeout(timer);
    },
    [duration]
  );

  const hideToast = useCallback(() => {
    setToast((prev) => ({ ...prev, show: false }));
  }, []);

  return {
    toast,
    showToast,
    hideToast,
  };
};
